/**
 * What an app reports as, when the environment says nothing.
 *
 * `instrumentation.ts` and `observabilityConfig.ts` both read these, so the
 * browser identity and the server identity cannot drift into two different
 * services in Grafana.
 */
export const OBSERVABILITY_FALLBACKS = {
    environment: 'staging',
    namespace: 'client-portal',
    version: 'unknown'
} as const
